











































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PickList from "../../../store/entities/pick-list";
import ViewPickListSerial from "./view-pick-list-serial.vue";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";
import PageRequest from "@/store/entities/page-request";

class PagePickListRequest extends PageRequest {
  keyword: string;
  refId: number;
  exceptPickListId: number;
}
@Component({
  components: { ViewPickListSerial },
})
export default class ViewPickList extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "picklist";
  plNamespace = "refPickList";

  picklist: PickList = new PickList();
  code: string = "";
  id: number = 0;
  viewModalShow: boolean = false;
  plPageRequest: PagePickListRequest = new PagePickListRequest();
  get plStore() {
    return this.$store.state.refPickList;
  }
  get items() {
    var re = this.$store.state.picklist.plPickings;
    var index = 0;
    var startIndex = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  //==========Ref PickList
  get plList() {
    var re = this.plStore.list;
    var startIndex = (this.plCurrentPage - 1) * this.plPageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get plLoading() {
    return this.plStore.loading;
  }
  plPageChange(page: number) {
    this.$store.commit(`${this.plNamespace}/setCurrentPage`, page);
    this.getplpage();
  }

  plPagesizeChange(pagesize: number) {
    this.$store.commit(`${this.plNamespace}/setPageSize`, pagesize);
    this.getplpage();
  }
  async searchPl() {
    this.plPageChange(1);
  }
  async getplpage() {
    if (this.picklist.type !== "PTO") {
      this.refreshListData();
      return;
    }
    this.plPageRequest.maxResultCount = this.plPageSize;
    this.plPageRequest.skipCount = (this.plCurrentPage - 1) * this.plPageSize;
    this.plPageRequest.refId = this.picklist.refId;
    this.plPageRequest.exceptPickListId = this.picklist.id;
    //filters
    await this.$store.dispatch({
      type: `${this.plNamespace}/getAll`,
      data: this.plPageRequest,
    });
  }

  get plPageSize() {
    return this.plStore.pageSize;
  }

  get plTotalCount() {
    return this.plStore.totalCount;
  }

  get plCurrentPage() {
    return this.plStore.currentPage;
  }
  refreshListData() {
    this.$store.commit(`${this.plNamespace}/refreshListData`);
  }
  //=========================================
  get loading() {
    return this.$store.state.purchaseOrder.loading;
  }

  async created() {
    this.code = this.$root.$router.currentRoute.params.code;
    await this.$store
      .dispatch({
        type: "picklist/view",
        data: { code: this.code },
      })
      .then((res) => {
        this.id = res.id;
        this.picklist = res;
        if (this.picklist.type === "PTO") {
          this.searchPl();
        }
      });
    await this.$store.dispatch({
      type: "picklist/viewPlPicking",
      data: { code: this.code },
    });
  }

  viewPlPickingSerial(index) {
    this.$store.commit(
      `${this.namespace}/viewInfoPlPicking`,
      this.items[index]
    );
    this.viewModalShow = true;
  }

  columns = [
    {
      width: 60,
      title: this.L("Order"),
      key: "orderNo",
    },
    {
      width: 150,
      title: this.L("ProductName"),
      key: "productName",
    },
    {
      width: 150,
      title: this.L("Sku"),
      key: "sku",
    },
    {
      width: 150,
      title: this.L("StorageType"),
      key: "storageTypeName",
    },
    {
      width: 150,
      title: this.L("Bin"),
      key: "allocatedLocationBinCode",
    },
    {
      width: 150,
      title: this.L("PickedTransport"),
      key: "pickedLocationTransportCode",
    },
    {
      width: 150,
      title: this.L("RefCode"),
      key: "refCode",
    },
    {
      width: 100,
      title: this.L("Qty"),
      key: "qty",
    },
    {
      width: 100,
      title: this.L("PickedQty"),
      key: "pickedQty",
    },
    {
      width: 150,
      title: this.L("PickedTime"),
      slot: "pickedTime",
    },
    {
      width: 150,
      title: this.L("RePickedByName"),
      key: "rePickedByName",
    },
    {
      width: 150,
      title: this.L("RePickedTime"),
      slot: "rePickedTime",
    },
    {
      width: 100,
      title: this.L("Action"),
      slot: "action",
      align: "center",
    },
  ];
  plColumns = [
    {
      title: this.L("Order"),
      width: 60,
      key: "orderNo",
    },
    {
      title: Util.L("Code"),
      width: 200,
      key: "code",
      slot: "pickList",
    },
    {
      title: Util.L("Type"),
      width: 200,
      key: "typeName",
    },
    {
      title: Util.L("Status"),
      width: 150,
      key: "statusName",
    },
    {
      title: Util.L("Employee"),
      width: 150,
      key: "employeeId",
      render: (h: any, params: any) => {
        return h(
          "span",
          `${params.row.employeeUserName} - ${params.row.employeeName}`
        );
      },
    },
    {
      title: Util.L("StartTime"),
      key: "startTime",
      width: 170,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.startTime));
      },
    },
    {
      title: Util.L("EndTime"),
      key: "endTime",
      width: 170,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.endTime));
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      width: 170,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
}
